import { AxiosInstance } from "axios"

export interface StripeOnboardResponse {
  apiStatus: string
  data: {
    stripeAccountId: string
    onboardingUrl: string
    expiresAt: string
  }
}

export function stripeOnboardApi(axiosInstance: AxiosInstance) {
  return axiosInstance({
    method: "post",
    url: "/agent/stripe/onboard",
  }) as Promise<{ data: StripeOnboardResponse }>
}
